export type RelationId = string & { readonly RelationId: unique symbol }
export type TemplateId = string & { readonly TemplateId: unique symbol }

export interface Path {
  from: TemplateId
  to: TemplateId
}

export interface Relation {
  id: RelationId
  name: string
  relatives: Relative[]
  allowedPaths: Path[]
}

export interface CreateRelationRequest {
  name: string
  relatives: TemplateId[]
}

export interface Relative {
  id: TemplateId
  name: string
  externalName: string
}

export enum EditRelationOperation {
  ADD = 'add',
  REMOVE = 'remove',
  REPLACE = 'replace',
  ADD_ALLOWED_PATH = 'addAllowedPath',
  REMOVE_ALLOWED_PATH = 'removeAllowedPath',
}

export interface RelationTemplate {
  templateId: TemplateId
  internalName: string
  externalName: string
  connections: number
}

type AddRelationRequest<T extends Record<string, unknown>> = T & {
  op: EditRelationOperation.ADD
}

type RemoveRelationRequest<T extends Record<string, unknown>> = T & {
  op: EditRelationOperation.REMOVE
}

export type UpdateRelationRequest<T extends Record<string, unknown>> = AddRelationRequest<T> | RemoveRelationRequest<T>

type AddAllowedPathRequest<T extends Record<string, unknown>> = T & {
  op: EditRelationOperation.ADD_ALLOWED_PATH
}

type RemoveAllowedPathRequest<T extends Record<string, unknown>> = T & {
  op: EditRelationOperation.REMOVE_ALLOWED_PATH
}

export type UpdateAllowedPathRequest<T extends Record<string, unknown>> = AddAllowedPathRequest<T> | RemoveAllowedPathRequest<T>

export type RelationUpdateRequest =
  | UpdateRelationRequest<{ templateId: TemplateId }>
  | UpdateAllowedPathRequest<{ from: TemplateId; to: TemplateId }>

type RelativeWithActionId = Relative & { actionId?: string }

type AdditionalRelativeProperties = {
  id: string
  relative: RelativeWithActionId
  type: 'relative'
}

type PathWithActionId = Path & { actionId?: string }

type AdditionalPathProperties = {
  id: string
  path: PathWithActionId
  type: 'path'
}

export type EditorChangeRequest = UpdateRelationRequest<AdditionalRelativeProperties> | UpdateAllowedPathRequest<AdditionalPathProperties>
